export const EMPTY_TIER_DATA = '---';